import dayjs from 'dayjs';

import { STORAGE_KEY } from '@/constants';

export const useGuest = () => {
  const setGuestSessionId = () => {
    //* 연도+월+일+시+분+밀리초
    sessionStorage.setItem(
      STORAGE_KEY.GUEST_SESSION_ID,
      `G${dayjs().format('YYMMDDHHmmssSSS')}`,
    );
  };

  const getGuestSessionId = () => {
    return sessionStorage.getItem(STORAGE_KEY.GUEST_SESSION_ID);
  };

  const removeGuestSessionId = () => {
    sessionStorage.removeItem(STORAGE_KEY.GUEST_SESSION_ID);
  };

  return {
    setGuestSessionId,
    getGuestSessionId,
    removeGuestSessionId,
  };
};
